<template>
  <div class="baniere pt-4 pb-20">
    <div class="w-full pt-4">
      <div class="titre w-full mt-5">
        Nos process
      </div>
      <div class="diviser ml-4">
        <divider
          :height="diviserHeight"
          :color="diviserColor"
        />
      </div>
    </div>

    <div class="mt-20">
      <div class="w-1/3">
        <div class="rounded-full cercle w-16 h-16 flex items-center justify-center">
          1
        </div>
      </div>

      <div class="image w-full justify-end mt-6">
        <img
          src="../../../assets/images/jpg/plan.jpg"
          alt="plan de travail"
        >
      </div>

      <div class="w-full pr-4 pt-6 mr-16">
        <div class="titre-item w-full mt-5">
          Project discovery
        </div>
        <div class="detail">
          Développer des produits dont personne n'a besoin est douloureux. Ensemble, nous allons suivre un processus de "design thinking" et essayer de comprendre en profondeur vos clients afin de pouvoir développer des produits qui répondent parfaitement à leurs besoins.
        </div>
      </div>
    </div>

    <div class="mt-20">
      <div class="flex w-full justify-end">
        <div class="w-1/3 flex justify-end">
          <div class="rounded-full cercle w-16 h-16 flex items-center justify-center">
            2
          </div>
        </div>
      </div>

      <div class="image w-full justify-end mt-6">
        <img
          src="../../../assets/images/jpg/tablette.jpg"
          alt="UX/UI Core image"
        >
      </div>

      <div class="w-full pr-4 pt-6 mr-16">
        <div class="titre-item w-full mt-5">
          UX/UI Core
        </div>
        <div class="detail">
          Maintenant que nous sommes sûrs que votre produit répond à un certain besoin, il est temps de réfléchir à la manière de le rendre facile à utiliser, beau et de garantir in fine une expérience utilisateur optimale.
        </div>
      </div>
    </div>

    <div class="mt-20">
      <div class="w-1/3">
        <div class="rounded-full cercle w-16 h-16 flex items-center justify-center">
          3
        </div>
      </div>

      <div class="image w-full justify-end mt-6">
        <img
          src="../../../assets/images/jpg/pc.jpg"
          alt="Développement image"
        >
      </div>

      <div class="w-full pr-4 pt-6 mr-16">
        <div class="titre-item w-full mt-5">
          Développement
        </div>
        <div class="detail">
          Nous créons des plateformes magnifiques, rapides et sécurisées, conçues exclusivement pour vos objectifs commerciaux. Du frontend au backend, nous sélectionnons les technologies les plus récentes et les plus innovantes avec lesquelles nous travaillons.
        </div>
      </div>
    </div>

    <div class="mt-20">
      <div class="flex w-full justify-end">
        <div class="w-1/3 flex justify-end">
          <div class="rounded-full cercle w-16 h-16 flex items-center justify-center">
            4
          </div>
        </div>
      </div>

      <div class="image w-full justify-end mt-6">
        <img
          src="../../../assets/images/jpg/pc2.jpg"
          alt="Déploiement & maintenance image"
        >
      </div>

      <div class="w-full pr-4 pt-6 mr-16">
        <div class="titre-item w-full mt-5">
          Déploiement & maintenance
        </div>
        <div class="detail">
          Il est temps de présenter votre tout nouveau produit à vos clients. Le voyage semble terminé. Cependant, nous restons à votre disposition pour maintenir et améliorer votre produit.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import divider from '@/components/helper/divider'

export default {
  name: 'Index',
  components: {
    divider
  },
  props: {
  },
  data () {
    return {
      diviserColor: '#9FB4FE',
      diviserHeight: '5px'
    }
  },
  created () {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/variables";
 .baniere{
   height: auto ;
   background-color: $white;
   position: relative;
   padding-left: $padding-l;
   padding-right: $padding-r;
 }

  .titre{
    font-weight: bold;
    font-size: 60px;
    line-height: 170%;
    letter-spacing: 0.01em;
    color: $text-black-dev;
  }
  .titre-item{
    font-weight: bold;
    font-size: 48px;
    line-height: 170%;
    letter-spacing: 0.01em;
    color: $text-black-dev;
  }
  .detail{
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 160%;
    color: $black;
  }

  .diviser {
    width: 30%;
  }

  .cercle{
    border: 4px solid #5F01D3;
    box-sizing: border-box;
    font-weight: 600;
    font-size: 42px;
    line-height: 50px;
    letter-spacing: 0.01em;
    color: #5F01D3;
  }
  @media screen and (max-width: 600px){
    .baniere{
      padding-left: 20px;
      padding-right: 20px;
    }
    .titre{
      font-size: 40px;
      line-height: 170%;
    }
    .title1{
      padding-right: 10px;
      font-size: 22px;
    }
    .titre-item{
      font-size: 32px;
    }
    .detail{
      font-size: 20px;
    }
    .diviser {
      width: 60%;
    }
    img{
      width: 372px;
      height: 267px;
    }
  }
</style>
